import axios from 'axios';
import csrfToken from '../../shared/meta';

export default function deleteWireBySlug(slug) {
  const headers = {
    'X-CSRF-Token': csrfToken(),
  };
  return axios.delete(`/wires/${slug}.json`, { headers });
}
